import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Helmet } from 'react-helmet-async';
import '../styles/Contact.css';

// Configure the API endpoint - this can be updated based on environment
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:3001/api/contact';

const validationSchema = Yup.object({
  name: Yup.string()
    .required('Name ist erforderlich')
    .min(2, 'Name muss mindestens 2 Zeichen lang sein'),
  email: Yup.string()
    .email('Ungültige E-Mail-Adresse')
    .required('E-Mail ist erforderlich'),
  phone: Yup.string()
    .matches(/^[0-9+\-\s()]*$/, 'Ungültige Telefonnummer'),
  message: Yup.string()
    .required('Nachricht ist erforderlich')
    .min(10, 'Nachricht muss mindestens 10 Zeichen lang sein')
});

const Contact = () => {
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSubmitStatus({
          type: 'success',
          message: 'Ihre Nachricht wurde erfolgreich gesendet. Ich werde mich zeitnah bei Ihnen melden!'
        });
        resetForm();
      } else {
        throw new Error(data.message || 'Ein Fehler ist aufgetreten');
      }
    } catch (error) {
      setSubmitStatus({
        type: 'error',
        message: 'Es gab ein Problem beim Senden Ihrer Nachricht. Bitte versuchen Sie es später erneut oder rufen Sie direkt an.'
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Kontakt | Alltagsbegleitung Jena – Catrin Kaßner</title>
        <meta name="description" content="Nehmen Sie Kontakt mit Catrin Kaßner auf – Alltagsbegleitung in Jena. Kostenloses Erstgespräch. Jetzt Nachricht senden oder direkt anrufen!" />
        <link rel="canonical" href="https://www.alltagsbegleitung-ckassner.de/contact" />
      </Helmet>
      <div className="page-background contact-background"></div>
      <div className="contact-container">
        <h1>Kontakt</h1>
        <p>Senden Sie mir eine Nachricht oder rufen Sie mich direkt an: <strong>(+49)17666617760</strong></p>
        
        {submitStatus.message && (
          <div className={`alert ${submitStatus.type}`}>
            {submitStatus.message}
          </div>
        )}

        <div className="disclaimer">
          <i className="fas fa-shield-alt"></i>
          <p>Datenschutzhinweis: Ihre hier eingegebenen Informationen werden nur zur Kontaktaufnahme verwendet und nicht gespeichert. Nach Bearbeitung Ihrer Anfrage werden alle Daten gelöscht.</p>
        </div>

        <Formik
          initialValues={{ name: '', email: '', phone: '', message: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <Field type="text" name="name" id="name" />
                <ErrorMessage name="name" component="div" className="error-message" />
              </div>

              <div className="form-group">
                <label htmlFor="email">E-Mail</label>
                <Field type="email" name="email" id="email" />
                <ErrorMessage name="email" component="div" className="error-message" />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Telefon</label>
                <Field type="tel" name="phone" id="phone" />
                <ErrorMessage name="phone" component="div" className="error-message" />
              </div>

              <div className="form-group">
                <label htmlFor="message">Nachricht</label>
                <Field as="textarea" name="message" id="message" />
                <ErrorMessage name="message" component="div" className="error-message" />
              </div>

              <button 
                type="submit" 
                className="submit-button" 
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Wird gesendet...' : 'Nachricht senden'}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default Contact;
